import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import {
    Box, InputBase, FormControl, IconButton, Grid, ListItem,
    Button, Dialog, DialogContent, DialogActions, Typography,
    Divider, RadioGroup, Radio, FormControlLabel, CircularProgress
} from '@material-ui/core';
import { useTranslate, useDataProvider, Loading } from 'react-admin';
import CustomPoper from '../CustomizedUIs/CustomPoper';
import CustomMessagePoper from './custom-message-popover';
import CustomTextField from '../CustomizedUIs/CustomTextFieldWithFontSize';
import {
    FONT_SIZE_LABEL
} from '../utils';
import DateTimePicker from '../common/date-time-picker';
import RadioButtonUncheckedIcon from '@material-ui/icons/RadioButtonUnchecked';
import RadioButtonCheckedIcon from '@material-ui/icons/RadioButtonChecked';
import SelectBoxInterval from '../common/select-box-interval';
import SelectBox from '../CustomizedUIs/CustomSelectBox'
import TextButton from '../CustomizedUIs/TextButton';
import CloseButton from '../CustomizedUIs/CloseButton';
import Field from '../users/CustomTextField';
import Snackbar from '../common/snackbar';

const useStyles = makeStyles((theme) => ({
    dialogPaper: {
        minHeight: '90vh',
        maxHeight: '90vh',
        maxWidth: '650px',
        backgroundColor: theme.palette.background.default
    },
    inputMulti: {
        width: '525px',
        borderRadius: '2px',
    },
    inputPopper: {
        alignSelf: 'flex-end',
        position: 'absolute',
        right: '16px',
        top: '20px'
    },
    send: {
        marginRight: '30px',
        height: '36px',
    },
    dialogActions: {
        paddingLeft: 32,
        paddingRight: 35,
        bottom: 0,
        right: 0,
    },
    divider: {
        marginTop: '14px'
    },
    btnClose: {
        fontFamily: " UniviaPro-Bold",
        fontSize: "10px",
        fontWeight: "bold",
        fontStretch: "normal",
        fontStyle: "normal",
        lineHeight: "normal",
        letterSpacing: "0.4px",
        color: "#4f5064",
    },
    Title: {
        fontFamily: "UniviaPro-Medium",
        fontSize: "18px",
        fontWeight: 500,
        fontStretch: "normal",
        fontStyle: "normal",
        lineHeight: 1.2,
        letterSpacing: "normal",
        color: "#4f5064",
        paddingBottom: "30px",
        marginTop: -10
    },
    titleRadio: {
        fontFamily: "UniviaPro-Medium",
        fontSize: "11px",
        fontWeight: 500,
        fontStretch: "normal",
        fontStyle: "normal",
        lineHeight: 1.2,
        letterSpacing: "normal",
        color: "#4f5064",
    },
    btnSend: {
        fontFamily: 'UniviaPro-Bold',
        fontSize: ' 11px',
        fontWeight: 'bold',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: ' 0.44px',
        color: '#ffffff',
    },
    boxBoder: {
        borderBottom: '1px solid',
        borderRight: '1px solid',
        borderBottomColor: theme.palette.grey['200'],
        borderRightColor: theme.palette.grey['200'],
    },
    TextValue: {
        fontFamily: 'UniviaPro',
        fontSize: '13px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.385,
        letterSpacing: '0.13px',
        color: '#88898c',
    }
}));

let dialogContent;
const DialogCreateCalendar = ({ loadingDialog, open, onClose, roomData, setUpdateCalendarEvents}) => {
    const translate = useTranslate();
    const dataProvider = useDataProvider();
    const classes = useStyles();

    // STATE
    const [type, setType] = useState("Information");
    const [reminder, setReminder] = useState({text:translate(`pos.messages.reminderNone`),value:-1});
    const [loading, setLoading] = useState(false);
    const [openPoper, setOpenPopper] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const [valueScheduleRadio, setValueScheduleRadio] = useState(0);
    const [dateSchedule, setDateSchedule] = useState(new Date());
    const [dateExpiration, setDateExpiration] = useState(new Date());
    const [fontSize, setFontSize] = useState(FONT_SIZE_LABEL.MEDIUM);
    const [resultMsg, setResultMsg] = useState({serverity:'success', message:''});
    const [selectedRecurrence, setSelectedRecurrence] = useState(null);
    const [openType, setOpenType] = useState(false)
    const [openReminder, setOpenReminder] = useState(false)
    const [listCalendarEvent, setListCalendarEvent]  = useState([]);
    const [error, setError] = useState({
        isError: true,
        message: ""
    });
    const [textValue, setTextValue] = useState({
        subject: '',
        content: '',
    });

    const textOnChange = prop => (e) => {
        setTextValue({
            ...textValue, [prop]: e.target.value
        })
        validate(prop, e.target.value)
    }

    const validate = (prop, value) => {
        if (prop === 'content') {
            if (value.length === 0) {
                setError(
                    value.length === 0 ? {
                        isError: true, message: translate('pos.messages.required')
                    } : {
                            isError: false, message: ''
                        }
                )
            }
            else {
                setError(
                    {
                        isError: false,
                        message: ''
                    }
                )
            }
        }
    }

    const handleClosePoper = () => {
        setOpenPopper(false);
    };

    const handleClickOpenPoper = (event) => {
        setAnchorEl(event.currentTarget);
        setOpenPopper(true);
    };

    const handleRadioScheduleChange = (event) => {
        setValueScheduleRadio(parseInt(event.target.value));
    };

    const clearDialog = () => {
        setTextValue({
            subject: '',
            content: '',
        });
        setFontSize(FONT_SIZE_LABEL.MEDIUM);
        setValueScheduleRadio(0);
        setSelectedRecurrence(null);
        setDateSchedule(new Date());
        setDateExpiration(new Date());
    }

    const handleClose = () => {
        clearDialog()
        onClose();
    }

    const onChangeRecurrence = (value) => {
        setSelectedRecurrence(value.name === 'None'?null:value);
    }

    const autoHideResultMessage = () => {
        setTimeout(() => {
            setResultMsg({serverity:'success', message:''});
        }, 6000);
    }

    const scrollTop = () => {
        const element = document.getElementById("DialogContentCalendar");
        element.scrollTop = 0;
    }


    const createCalendarEvent = () => {
        // {
        //     "title":"Möte med doktor", 
        //     "body":"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim polers.", 
        //     "interval":"none", 
        //     "schedule": 1689389757000, 
        //     "expiration":0, 
        //     "calendartype":"Information", 
        //     "room":1
        // }
        setLoading(true);
        const calendarEvent = {
            title: textValue.subject,
            body: textValue.content,
            interval: (valueScheduleRadio === 1 && selectedRecurrence)?selectedRecurrence.value:"none",
            schedule: valueScheduleRadio === 1?dateSchedule.getTime():dateExpiration.getTime(), 
            expiration: (valueScheduleRadio === 1 && dateExpiration)?dateExpiration.getTime():0,
            reminder:reminder.value,
            fontSize:fontSize,
            calendartype: type??"Information",
            room: roomData.id
        } 
        
        dataProvider('CREATE', 'calendar', {data:calendarEvent}).then(response => {
            setLoading(false)
            setResultMsg({serverity:'success', message:translate(response.message)});
            scrollTop();
            setUpdateCalendarEvents(Math.random());
        }).catch(error => {
            setLoading(false);
            console.error('CREATE CALENDAR:', error);
            setResultMsg({serverity:'success', message:translate(error.message)});
        });   
        autoHideResultMessage();
    }

    const handleCreateCalendarEvent = () => {
        createCalendarEvent();
    }

    const disableSendButton = () => {
        return textValue.content === '';
    }

    const handleOpenType = () => {
        setOpenType(!openType)
    }

    const handleOpenReminder = () => {
        setOpenReminder(!openReminder)
    }

    const pickTypeValue = (value) => {
        if (value !== type) {
            setType(value)
        }
        setOpenType(false)
    }

    const pickReminderValue = (e) => {
        if (e !== reminder) {
            setReminder(e)
        }
        setOpenReminder(false)
    }

    const reminderList = [
        {
            text:translate(`pos.messages.reminderNone`),
            value:-1
        },
        {
            text:translate(`pos.messages.reminderOnTime`),
            value:0
        },
        {
            text:translate(`pos.messages.reminder5MinBefore`),
            value:5
        },
        {
            text:translate(`pos.messages.reminder10MinBefore`),
            value:10
        },
        {
            text:translate(`pos.messages.reminder15MinBefore`),
            value:15
        },
        {
            text:translate(`pos.messages.reminder20MinBefore`),
            value:20
        },
        {
            text:translate(`pos.messages.reminder25MinBefore`),
            value:25
        },
        {
            text:translate(`pos.messages.reminder30MinBefore`),
            value:30
        }
    ]

    const getListType = () => {
        setLoading(true)
        dataProvider('GET_LIST', "calendartype", {
            filter: {},
            skip:-1,
            sort: { field: 'id', order: 'ASC'},
            pagination: {}
        }).then(({ data }) => {
            data.map((eventType) => {
              if(eventType.type)
                listCalendarEvent.push({ value: eventType.type, color: JSON.parse(eventType.jsonType).dcolor, id: eventType.id })
            })
            setListCalendarEvent(listCalendarEvent);
            setLoading(false)
        }).catch(() => {
            setLoading(false)
        });
    }

    useEffect(()=>{
        getListType();
    },[])
    return (
        <Dialog open={open} scroll='paper' onClose={handleClose} classes={{ paper: classes.dialogPaper }} fullWidth={true} disableEnforceFocus>
            <Box mx={5} mt={3} ref={node => dialogContent = node}>
                <Box display='flex' justifyContent='flex-end' alignItems='center'>
                    <Typography className={classes.btnClose}>{translate(`pos.user.close`)}</Typography>
                    <CloseButton onClick={handleClose} />
                </Box>
                <Typography className={classes.Title}>{translate(`resources.alarm.createCalendar`)}</Typography>
            </Box>
            {
                loadingDialog ? <Box style={{ height: '74vh' }}><Loading /></Box> : (
                    <DialogContent style={{ padding: '8px 40px' }} id="DialogContentCalendar">
                    <Snackbar
                        id='snackbar-create-calendar'
                        show={resultMsg.message.length > 0}
                        message={resultMsg.message}
                        onClose={() => autoHideResultMessage()}
                    />

                    <Box mt={4} mx={2.5}>
                        <FormControl component="fieldset">
                            <Grid container spacing={1} alignItems="center" >
                                <Grid item>
                                    <Typography className={classes.titleRadio} >{translate(`pos.messages.schedule`)}</Typography>
                                </Grid>
                                <Grid item>
                                    <CustomMessagePoper
                                        open={openPoper}
                                        anchorEl={anchorEl}
                                        handleClick={handleClickOpenPoper}
                                        handleClose={handleClosePoper}
                                        title={translate(`pos.messages.schedule`)}
                                        content={translate(`pos.alarm.constentSchedule`)}
                                        icon={<b>?</b>}
                                    />
                                </Grid>
                            </Grid>
                            <RadioGroup row aria-label="position" name="position" value={valueScheduleRadio} onChange={handleRadioScheduleChange}>
                                <FormControlLabel value={0} control={<Radio color="primary" icon={<RadioButtonUncheckedIcon style={{ fontSize: '24px' }} />} checkedIcon={<RadioButtonCheckedIcon style={{ fontSize: '24px' }} />} />} classes={{ label: classes.titleRadio }} label={translate(`resources.messages.OneTime`)} />
                                <FormControlLabel value={1} control={<Radio color="primary" icon={<RadioButtonUncheckedIcon style={{ fontSize: '24px' }} />} checkedIcon={<RadioButtonCheckedIcon style={{ fontSize: '24px' }} />} />} classes={{ label: classes.titleRadio }} label={translate(`resources.messages.Repeatly`)} style={{ marginLeft: '63px' }} />
                            </RadioGroup>
                        </FormControl>
                    </Box>
                    <SelectBoxInterval
                        open={valueScheduleRadio === 1}
                        recurrence={selectedRecurrence}
                        onSelect={onChangeRecurrence}
                    />
                    <DateTimePicker
                        open={valueScheduleRadio === 1}
                        date={dateSchedule}
                        setDate={setDateSchedule}
                        style="calendar"
                        minDate={new Date()}
                        title={translate(`resources.reviews.fields.date`)}
                    />
                    <Divider className={classes.divider} />
                    <DateTimePicker
                        minDate={new Date()}
                        title={translate(`resources.reviews.fields.date`)}
                        open={true}
                        date={dateExpiration}
                        setDate={setDateExpiration}
                        style='calendar'
                    />
                   <Box mt={4} mx={2.5}>
                        <SelectBox
                            label={translate(`pos.messages.type`)} alignItems="center"
                            value={<Typography>{type}</Typography>}
                            open={openType}
                            handleClick={handleOpenType}
                            required={true}
                        >
                            {
                                listCalendarEvent.map((e, index) => (
                                    <ListItem className={classes.boxBoder} style={{ padding: '8px' }} button onClick={() => pickTypeValue(e.value)}>
                                        <Typography className={classes.TextValue}>{e.value}</Typography>
                                    </ListItem>
                                ))
                            }
                        </SelectBox>
                    </Box>
                    <Box mt={4} mx={2.5}>
                        <SelectBox
                            label={translate(`pos.messages.reminder`)} alignItems="center"
                            value={<Typography>{reminder.text}</Typography>}
                            open={openReminder}
                            handleClick={handleOpenReminder}
                            required={true}
                        >
                            {
                                reminderList.map((e, index) => (
                                    <ListItem className={classes.boxBoder} style={{ padding: '8px' }} button onClick={() => pickReminderValue(e)}>
                                        <Typography variant='h6' className={classes.TextValue}>{e.text}</Typography>
                                    </ListItem>
                                ))
                            }
                        </SelectBox>
                    </Box>
                    <Divider className={classes.divider} />
                    <Box mt={4} mx={2.5}>
                        <Field
                            id="filled-basic"
                            label={translate(`pos.messages.subject`)}
                            value={textValue.subject}
                            onChange={textOnChange('subject')}
                            style={{ width: 525 }}
                            endDom={<CustomPoper
                                open={openPoper}
                                anchorEl={anchorEl}
                                handleClick={handleClickOpenPoper}
                                handleClose={handleClosePoper}
                                title={translate(`pos.messages.subject`)}
                                content={translate(`pos.messages.constentSubject`)}
                                icon={<b>?</b>}
                            />}
                        />
                    </Box>
                    <Box mt={4.9} mx={2.5}>
                        <CustomTextField
                            onBlur={() => {
                                validate('content', textValue.content)
                            }}
                            className={classes.inputMulti}
                            id="textfield-message"
                            multiline
                            rows={4}
                            value={textValue.content}
                            onChange={textOnChange('content')}
                            placeholder={`${translate(`pos.messages.placeholder`)} *`}
                            error={error.message !== "" && error.isError}
                            helperText={error.message}
                            isDyslexieEnable={false}
                            fontSize={fontSize}
                            setFontSize={setFontSize}
                            endDom={
                                <Box>
                                    <Box className={classes.inputPopper}>
                                        <CustomPoper
                                            open={openPoper}
                                            anchorEl={anchorEl}
                                            handleClick={handleClickOpenPoper}
                                            handleClose={handleClosePoper}
                                            title={translate(`pos.messages.constent`)}
                                            content={translate(`pos.messages.constentContent`)}
                                            icon={<b>?</b>}
                                        />
                                    </Box>
                                </Box>
                            }
                        />
                    </Box>
                    </DialogContent>
                )
            }
            {!loadingDialog &&
                <DialogActions className={classes.dialogActions}>
                    <TextButton mr={2} style={{ marginTop: "1em" }} onClick={handleClose}/>
                    <Button
                        disabled={disableSendButton()}
                        variant="contained"
                        className={classes.send}
                        size="large"
                        color="primary"
                        onClick={handleCreateCalendarEvent}
                    >
                        {loading ? (
                            <CircularProgress
                                size={25}
                                thickness={2}
                                color='inherit'
                            />
                        ) :
                            <Typography className={classes.btnSend}>{translate('pos.alarm.createCalendar')}</Typography>
                        }
                    </Button>
                </DialogActions>
            }

        </Dialog>
    )
}

DialogCreateCalendar.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired
};

export default DialogCreateCalendar;
